import React, { useEffect, useMemo, useState } from "react";
import axios from "axios";
import { useAuth } from "../../../../context/AuthContext";
import "./UserSubject.css";

const TAGS = {
    1: { name: "Listening / Dinleme", color: "#C85AC9" },
    2: { name: "Writing / Yazma", color: "#9DC97B" },
    4: { name: "Reading / Okuma", color: "#FF7F27" },
    5: { name: "Speaking / Konuşma", color: "#5DE5F5" },
};

// tagId=3 (Konu Anlatım Videosu) rapora dahil değil
const EXCLUDED_TAG_ID = 3;

function pct(correct, total) {
    if (!total) return 0;
    return Math.round((correct / total) * 100);
}

function Bar({ rate, color }) {
    return (
        <div className="progress modern-progress">
            <div
                className="progress-bar modern-progress-bar"
                style={{
                    width: `${rate}%`,
                    backgroundColor: color,
                }}
            >
                %{rate}
            </div>
        </div>
    );
}

function UserSubject() {
    const { user } = useAuth();
    const [loading, setLoading] = useState(true);
    const [err, setErr] = useState(null);
    const [reportData, setReportData] = useState([]);

    const [availableCourses, setAvailableCourses] = useState([]);
    const [selectedCourseId, setSelectedCourseId] = useState("");

    useEffect(() => {
        fetchCourses();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if (selectedCourseId) {
            fetchReport(selectedCourseId);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedCourseId]);

    const fetchCourses = async () => {
        try {
            setLoading(true);
            setErr(null);

            const headers = {
                accept: "*/*",
                "Content-Type": "application/json",
                Authorization: "Bearer " + user.token,
            };

            const res = await axios.get(
                "https://api.heryerdeingilizce.com/api/user/Opt/GetCourse",
                { headers }
            );

            const userCourseIds = user?.educationals?.map((x) => x.courseId) || [];
            const matchedCourses = (res.data?.data?.courses || []).filter((x) =>
                userCourseIds.includes(x.id)
            );

            setAvailableCourses(matchedCourses);

            if (matchedCourses.length > 0) {
                setSelectedCourseId(matchedCourses[0].id);
            } else {
                setLoading(false);
            }
        } catch (e) {
            setErr("Kurslar yüklenirken hata oluştu.");
            setLoading(false);
        }
    };

    const fetchReport = async (courseId) => {
        try {
            setLoading(true);
            setErr(null);

            const headers = {
                accept: "*/*",
                "Content-Type": "application/json",
                Authorization: "Bearer " + user.token,
            };

            const res = await axios.get(
                "https://api.heryerdeingilizce.com/api/user/Opt/MyReportByCourse",
                {
                    headers,
                    params: { courseId }
                }
            );

            setReportData(res.data?.data || []);
        } catch (e) {
            setErr("Veriler yüklenirken hata oluştu.");
        } finally {
            setLoading(false);
        }
    };
    const toPlainOptionLabel = (str = "") =>
        str
            .replace(/<\s*sup\s*>/gi, "")   // <sup>
            .replace(/<\s*\/\s*sup\s*>/gi, ""); // </sup>
    const subjects = useMemo(() => {
        const subjectsMap = {};

        reportData.forEach((course) => {
            const courseId = course.courseId;
            const courseName = course.courseName;

            course.subjects.forEach((subj) => {
                const subjectId = subj.subjectId;
                const subjectName = subj.subjectName;

                if (!subjectsMap[subjectId]) {
                    subjectsMap[subjectId] = {
                        subjectId,
                        subjectName,
                        courseId,
                        courseName,
                        total: 0,
                        correct: 0,
                        wrong: 0,
                        rate: 0,
                        tags: {
                            1: { total: 0, correct: 0, wrong: 0, rate: 0 },
                            2: { total: 0, correct: 0, wrong: 0, rate: 0 },
                            4: { total: 0, correct: 0, wrong: 0, rate: 0 },
                            5: { total: 0, correct: 0, wrong: 0, rate: 0 },
                        },
                    };
                }

                subj.answers.forEach((a) => {
                    if (a.isDeleted) return;
                    if (a.tagId === EXCLUDED_TAG_ID) return;

                    subjectsMap[subjectId].total += 1;
                    if (a.isTrue) subjectsMap[subjectId].correct += 1;

                    if (subjectsMap[subjectId].tags[a.tagId]) {
                        subjectsMap[subjectId].tags[a.tagId].total += 1;
                        if (a.isTrue) subjectsMap[subjectId].tags[a.tagId].correct += 1;
                    }
                });
            });
        });

        Object.values(subjectsMap).forEach((s) => {
            s.wrong = s.total - s.correct;
            s.rate = pct(s.correct, s.total);

            Object.keys(s.tags).forEach((tagId) => {
                const t = s.tags[tagId];
                t.wrong = t.total - t.correct;
                t.rate = pct(t.correct, t.total);
            });
        });

        return Object.values(subjectsMap).sort((a, b) => a.subjectId - b.subjectId);
    }, [reportData]);

    if (loading) return <div>Yükleniyor...</div>;
    if (err) return <div>{err}</div>;

    return (
        <div className="container mt-3">
            <div className="mb-3">
                <label className="form-label"><strong>Kurs Seçiniz</strong></label>
                <select
                    className="form-select"
                    value={selectedCourseId}
                    onChange={(e) => setSelectedCourseId(Number(e.target.value))}
                >
                    {availableCourses.map((course) => (
                        <option key={course.id} value={course.id}>
                            {toPlainOptionLabel(`${course.courseName} - ${course.courseDesc}`)}

                        </option>
                    ))}
                </select>
            </div>

            <div className="card shadow-sm">
                <div className="card-header bg-white">
                    <h4 className="mb-0">Konu Bazlı Rapor</h4>
                </div>

                <div className="card-body">
                    {subjects.length === 0 && (
                        <div className="text-muted">Kayıt bulunamadı.</div>
                    )}

                    {subjects.map((s) => {
                        const subjectTitle =
                            (s.subjectName && s.subjectName.trim()) ||
                            `Subject #${s.subjectId}`;

                        const courseTitle =
                            (s.courseName && s.courseName.trim()) ||
                            (s.courseId ? `Course #${s.courseId}` : "");

                        const accordionId = `subj_${s.subjectId}`;

                        return (
                            <div key={s.subjectId} className="mb-4">
                                <div className="border rounded p-3 modern-subject-card">
                                    <div className="d-flex justify-content-between flex-wrap gap-2">
                                        <div>
                                            <h5
                                                className="mb-1"
                                                dangerouslySetInnerHTML={{ __html: subjectTitle }}
                                            />
                                            {courseTitle && (
                                                <strong
                                                    className="text-muted"
                                                    dangerouslySetInnerHTML={{ __html: courseTitle }}
                                                />
                                            )}
                                        </div>

                                        <div className="text-end">
                                            <div>
                                                <strong>
                                                    {s.total} soru · {s.correct} doğru · {s.wrong} yanlış
                                                </strong>
                                            </div>
                                            <div className="text-muted">Başarı: %{s.rate}</div>
                                        </div>
                                    </div>

                                    <div className="mt-2">
                                        <Bar
                                            rate={s.rate}
                                            color={s.rate >= 60 ? "success" : "warning"}
                                        />
                                    </div>

                                    <div className="text-center mt-2">
                                        <button
                                            className="btn btn-sm btn-outline-primary rounded-pill modern-pill-btn"
                                            type="button"
                                            data-bs-toggle="collapse"
                                            data-bs-target={`#${accordionId}`}
                                            aria-expanded="false"
                                            aria-controls={accordionId}
                                        >
                                            Tür Bazlı Rapor
                                        </button>
                                    </div>

                                    <div id={accordionId} className="collapse mt-3 modern-collapse">
                                        <div className="row g-3">
                                            {Object.keys(TAGS).map((tagIdStr) => {
                                                const tagId = Number(tagIdStr);
                                                const meta = TAGS[tagId];
                                                const t = s.tags[tagId];

                                                return (
                                                    <div className="col-12" key={tagId}>
                                                        <div className="p-3 border rounded">
                                                            <div className="d-flex justify-content-between flex-wrap gap-2">
                                                                <strong>{meta.name}</strong>
                                                                <small className="text-muted">
                                                                    {t.total} soru · {t.correct} doğru ·{" "}
                                                                    {t.wrong} yanlış
                                                                </small>
                                                            </div>
                                                            <div className="mt-2">
                                                                <Bar rate={t.rate} color={meta.color} />
                                                            </div>
                                                        </div>
                                                    </div>
                                                );
                                            })}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        );
                    })}
                </div>

                <div className="card-footer bg-white text-end">
                    <button
                        onClick={() => fetchReport(selectedCourseId)}
                        className="btn btn-sm btn-primary"
                    >
                        Yenile
                    </button>
                </div>
            </div>
        </div>
    );
}

export default UserSubject;